import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3bda096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-page" }
const _hoisted_2 = { class: "operation" }
const _hoisted_3 = { class: "table" }

import { onMounted, ref, watch, onUnmounted } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { PAGE_SIZES, CODE_ENUM, PRODUCT_TYPE } from '@/common'
import ProductForm from './components/product-form-drawer.vue'
import { queryProductPage, productInfoDelete } from '@/api'
import { ElMessage } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'
import { useProductStore } from '@/stores/product'
import { msgbox } from '@/utils'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const router = useRouter()

const productTypeOps = [
  {
    label: '卫星单模终端',
    value: PRODUCT_TYPE.SINGLE_GATEWAY,
  },
  {
    label: '多模网关',
    value: PRODUCT_TYPE.MULTI_GATEWAY,
  },
  {
    label: '传感器',
    value: PRODUCT_TYPE.SENSOR,
  },
  {
    label: 'Lora设备',
    value: PRODUCT_TYPE.LORA,
  },
  {
    label: '星地一体机',
    value: PRODUCT_TYPE.SATELLITE_GROUND,
  },
  {
    label: '直连设备',
    value: PRODUCT_TYPE.DIRECT_CONNECT,
  },
]

const advancedRef = ref()

const tableData: any = ref([])
const formInline = ref({
  productKey: '',
  productName: '',
  productType: '',
})

const buttonList = ref([
  {
    type: 'edit',
    text: '编辑',
  },
  {
    type: 'delete',
    text: '删除',
  },
])

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const col = [
  {
    prop: 'productName',
    label: '产品名称',
  },
  {
    prop: 'productKey',
    label: '产品ID',
  },
  {
    prop: 'productTypeValue',
    label: '类型',
  },
  {
    prop: 'productModel',
    label: '硬件代码',
  },
  {
    prop: 'producer',
    label: '厂商/品牌',
    formatter: ({ producer, brand }: any) => {
      return [producer, brand].filter(Boolean).join('/')
    },
  },
]

const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryProductPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const productConf: any = ref({
  visible: false,
  data: {},
})

const toProductForm = (data = {}) => {
  productConf.value = {
    visible: true,
    data,
  }
}

const toDelete = ({ productKey }: any) => {
  msgbox({
    tip: '你确定要删除这个产品吗？',
    thenFn: () => handleDelete({ productKey }),
  })
}

const handleDelete = async ({ productKey }: any) => {
  const res: any = await productInfoDelete([productKey])
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('操作成功')
  }

  fetchList()
}

const onModel = ({ productKey }: any) => {
  router.push({
    path: '/product/product-list/model',
    query: {
      productKey,
    },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advance-container",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "产品ID",
            prop: "productKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.productKey,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.productKey) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "产品名称",
            prop: "productName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.productName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.productName) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "productType",
            label: "类型"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.productType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.productType) = $event)),
                placeholder: "请选择产品类型",
                class: "ws_select",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productTypeOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: toProductForm,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加产品")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "ws_common_table ws_mt20",
          data: tableData.value
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
              return _createVNode(_component_el_table_column, {
                key: index,
                prop: item.prop,
                label: item.label,
                formatter: item.formatter,
                "show-overflow-tooltip": ""
              }, null, 8, ["prop", "label", "formatter"])
            }), 64)),
            _createVNode(_component_el_table_column, {
              width: 320,
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: buttonList.value,
                  scope: scope.row,
                  onOnEdit: toProductForm,
                  onOnDelete: toDelete,
                  onOnModel: onModel
                }, null, 8, ["buttonList", "scope"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(ProductForm, {
      visible: productConf.value.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((productConf.value.visible) = $event)),
      data: productConf.value.data,
      onSuccess: fetchList,
      productTypeOps: productTypeOps
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})